export const ExplorerLinks = {
  1: 'https://etherscan.com',
  42161: 'https://arbiscan.io',
  56: 'https://bscscan.com',
  43114: 'https://snowtrace.io/',
  7700: 'https://tuber.build/',
  10: 'https://optimistic.etherscan.io',
  137: 'https://polygonscan.com',
  53935: 'https://subnets.avax.network/defi-kingdoms',
  8217: 'https://scope.klaytn.com',
  250: 'https://ftmscan.com',
  25: 'https://cronoscan.com',
  288: 'https://bobascan.com',
  1088: 'https://andromeda-explorer.metis.io',
  1313161554: 'https://explorer.mainnet.aurora.dev',
  1666600000: 'https://explorer.harmony.one',
  1284: 'https://moonbeam.moonscan.io',
  1285: 'https://moonriver.moonscan.io',
  2000: 'https://explorer.dogechain.dog',
  8453: 'https://basescan.org',
  81457: 'https://blastscan.io',
  534352: 'https://scrollscan.com',
  59144: 'https://lineascan.build',
}

export const ExplorerNames = {
  1: 'Etherscan',
  42161: 'Arbiscan',
  56: 'BscScan',
  43114: 'Snowtrace',
  7700: 'Canto Explorer',
  10: 'Optimism Explorer',
  137: 'PolygonScan',
  53935: 'DFK Subnet Explorer',
  8217: 'Klaytn Explorer',
  250: 'FTMScan',
  25: 'CronoScan',
  288: 'Boba Explorer',
  1088: 'Metis Explorer',
  1313161554: 'Aurora Explorer',
  1666600000: 'Harmony Explorer',
  1284: 'Moonbeam Explorer',
  1285: 'Moonriver Explorer',
  2000: 'Dogechain Explorer',
  8453: 'BaseScan',
  81457: 'Blastscan',
  534352: 'Scrollscan',
  59144: 'LineaScan',
}
